import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import BlogSidebarMain from './BlogSidebarMain';
import Footer from '../../components/Footer';

const BlogSidebar = () => {
  return (
    <>
      <HeaderSeven />

      <BlogSidebarMain />

      <Footer />
    </>
  );
};

export default BlogSidebar;
